import { type ActionTypeOrganizationAdditionalInfoConfig } from '@/api';
import { isMissingTranslation } from '@/utils/isMissingTranslation';

export const hasAdditionalInfoConfigError = (
  additionalInfoConfig: ActionTypeOrganizationAdditionalInfoConfig
): boolean => {
  return additionalInfoConfig.some((element) => {
    if (element.type === 'text' || element.type === 'text-area') {
      const isMissingLabel = isMissingTranslation(element.config.label);
      const isMissingPlaceholder = isMissingTranslation(element.config.placeholder);

      return isMissingLabel || isMissingPlaceholder;
    } else if (element.type === 'select') {
      const isMissingLabel = isMissingTranslation(element.config.label);
      const isMissingPlaceholder = isMissingTranslation(element.config.placeholder);
      const hasNoOptions = !element.config.options.length;
      const isMissingOptionLabel = element.config.options.some((option) =>
        isMissingTranslation(option.label)
      );

      return isMissingLabel || isMissingPlaceholder || hasNoOptions || isMissingOptionLabel;
    } else if (element.type === 'number') {
      const isMissingLabel = isMissingTranslation(element.config.label);

      return isMissingLabel;
    }
  });
};
